import { render } from "./B2bFiltersDocumentacionDocumentos.vue?vue&type=template&id=75cc6862&scoped=true&lang=pug"
import script from "./B2bFiltersDocumentacionDocumentos.vue?vue&type=script&lang=js"
export * from "./B2bFiltersDocumentacionDocumentos.vue?vue&type=script&lang=js"

import "./B2bFiltersDocumentacionDocumentos.vue?vue&type=style&index=0&id=75cc6862&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75cc6862"]])

export default __exports__